import React, { useContext, useState } from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { ContextGloball } from '../Context/ContextGlobal';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'top',
            labels: {
                color: 'white',
                fontSize:15
            }
        },
        title: {
            display: true,
            text: 'Reporte ventas de cada sucursal',
            color: 'white',
            fontSize: 18,
        }
    },
    scales: {
        y: {
            ticks: {
                color: 'white',
                fontSize: 12,
            }
        },
        x: {
            ticks: {
                color: 'white',
                fontSize: 12,
            }
        },
    }
};
const infPedido = {
    'A': { 'nombre': 'Aplicación', 'color': '#FF4000' },
    'P': { 'nombre': 'Pagina WEB', 'color': '#5F04B4' },
    'T': { 'nombre': 'Telefónico', 'color': '#FFFF00' },
    'W': { 'nombre': 'WhatsApp', 'color': '#00FF00' }
}
const server = process.env.REACT_APP_SERVER;
function GraficaTipoPedido() {
    const {loading,setLoading} = useContext(ContextGloball);
    const [esSemana, setEsSemana] = useState(false);
    const [regional, setRegional] = useState('');
    const [fechaIni, setFechaIni] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [data, setData] = useState({
        labels: [],
        datasets: [
            {
                label: "Cantidad",
                data: [],
                backgroundColor: [],
                barPercentage: 1.0,
            },
        ],
    });
    function getLista(sucursales, lista, tipo) {
        var listaGenerada = []
        for (var sc of sucursales) {
            if (lista.length !== 0) {
                var dataFilt = lista.filter(item => item.ID_SUCURSAL_DESTINO == sc);
                if (dataFilt.length == 0) {
                    listaGenerada.push(0);
                } else {
                    listaGenerada.push(dataFilt[0].CANT);
                }
            } else {
                listaGenerada.push(0)
            }
        }
        return listaGenerada
    }
    function graficarReporte() {
        var valTipo = esSemana ? fechaFin != '' : true
        var bandera = esSemana ? 1 : 0
        if (regional != '' && fechaIni != '' && valTipo) {
            setLoading(true);
            fetch(`${server}/graficos/getReporteTipoVenta`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, fechaIni, fechaFin, 'esSemana': bandera
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        var tipoPedido = [...new Set(data.ok.map(item => item.TIPO_REGISTRO))];
                        var label = new Set(data.ok.map(item => item.SUCURSAL))
                        var sucLis = [...new Set(data.ok.map(item => item.ID_SUCURSAL_DESTINO))]
                        var datasets = []
                        for (var tp of tipoPedido) {
                            var datosFiltrado = data.ok.filter((item) => item.TIPO_REGISTRO == tp)
                            datasets.push({
                                label: infPedido[tp].nombre,
                                data: getLista(sucLis, datosFiltrado, infPedido[tp]),
                                backgroundColor: infPedido[tp].color,
                                barPercentage: 1.0,
                            })
                        }
                        var dataAux = {
                            labels: [...label],
                            datasets,
                        }
                        setData(dataAux)
                    } else {
                        console.log(data.error);
                    }
                    setLoading(false);
                })
                .catch(err => console.log("problemas antes de enviar", err));
        } else {
            console.log("completa la informacion")
        }
    }
    useState(() => {
        var dataIni = JSON.parse(localStorage.getItem('info'));
        setRegional(dataIni.ID_REGIONAL_ACTUAL)
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1' >
                <div className='row row-cols g-1'style={{marginRight:'40px'}}>
                    <div className='col' style={{maxWidth:'180px',minWidth:'180px'}}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light ">{esSemana ? 'Fecha Inicial' : 'Fecha'}</span>
                            <input type="date" className="form-control" value={fechaIni} onChange={(e) => setFechaIni(e.target.value)} />
                        </div>
                    </div>
                    {esSemana && <div className='col' style={{maxWidth:'180px',minWidth:'180px'}}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light">Fecha Final</span>
                            <input type="date" className="form-control" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                        </div>
                    </div>}
                    <div className='col' style={{maxWidth:'170px',minWidth:'170px'}}>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" checked={esSemana} onChange={() => setEsSemana(!esSemana)} />
                            <label className="form-check-label text-light lh-sm" style={{fontSize:'12px'}}>
                                {esSemana ? 'Desactivar rango fecha' : 'Activar graficos por fecha'}
                            </label>
                        </div>
                    </div>
                    <div className='col' style={{maxWidth:'100px',minWidth:'100px'}}>
                        <button className='btn btn-success bg-gradient btn-sm w-100' onClick={() => graficarReporte()}><i className="fa-solid fa-chart-simple"></i> Graficar</button>
                    </div>
                </div>
            </div>
            <div className='container-fluid bg-dark bg-gradient'>
                <Bar options={options} data={data} updateMode='resize' height={600} style={{ color: '#ffffff' }} />
            </div>
        </>
    )
}

export default GraficaTipoPedido